import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { MineInsidersUtils } from 'src/app/shared/components/utils/mineInsiders-util';
import {Minier} from '../../shared/components/models/minier';
import {SearchParam} from '../../shared/components/models/search-param';
import {Entreprise} from '../../shared/components/models/entreprise';

@Injectable({
  providedIn: 'root'
})
export class RessourceService {
  private serviceURL: string;
  private httpOptions: any;

  constructor(private http: HttpClient) {
    this.serviceURL = environment.apiUrl;
    this.httpOptions = new MineInsidersUtils().httpHeaders();
  }

  public findAll() {
    return this.http.get(this.serviceURL + '/ressource/find/enabled', this.httpOptions);
  }
  public findById(id) {
    return this.http.get(this.serviceURL + '/ressource/find/' + id, this.httpOptions);
  }
}
